import gql from "graphql-tag";
import { DOCUMENT_FRAGMENT } from "../document/fragment";

export const COMPANY_FRAGMENT = gql`
  fragment CompanyInfo on Company {
    address
    city
    code
    countryIsoCode
    countryTaxResidenceIsoCode
    email
    existingCompany
    isAutocomplete
    isIndividual
    legalAddress
    legalCity
    legalCountryIsoCode
    legalFormId
    legalPostcode
    leiCode
    name
    postcode
    registrationDate
    step
    taxpayerIdentificationNumber
    documents {
      ...DocumentInfo
    }
    accountPurposes
    expectedMonthlyExpensesValue
  }
  ${DOCUMENT_FRAGMENT}
`;
